import React from "react";
import { graphql } from "gatsby";
import { Image as ImageComponent } from "@zempler/theme/src/components/image/Image";

export const LandscapeImage = ({ data, ...rest }) => {
  return (
    <ImageComponent
      src={data?.image?.image?.localFile}
      alt={data?.image?.image?.altText}
      roundedCorners
      border
    />
  );
};

export const LandscapeImageQuery = graphql`
  fragment LandscapeImage on UMBRACO_LandscapeImageComponentType {
    image {
      image {
        ...LandscapeImageImage
      }
    }
  }
`;
